/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { StatusCode } from 'helpers/app.config';
import {
  AutocompleteElement,
  TextFieldElement
} from 'components/muiInputWrappers';
import { useGlobalContext } from 'context/GlobalContext';
import useGetAllPartners from 'hooks/catalog/useGetAllPartners';
import useGetClientStatusList from 'hooks/client/useGetClientStatusList';
import { FilterContext } from 'context/FilterContext';
import { KEYS } from 'helpers/react-query.config';
import catalog from 'api/catalog';

export type FormFields = {
  ticketId?: number;
  ticketsStatusIds?: number[];
  remote: boolean;
  delayClassificationId?: number;
  partnerIds?: number;
};

type Props = {
  form: UseFormReturn<FormFields>;
};

function TicketsSearching({ form }: Props) {
  const { hasPerm } = useGlobalContext();
  const { allPartners, isAllPartnersLoading } = useGetAllPartners({
    enabled: true
  });
  const { storedFilter } = useContext(FilterContext);

  const [isRemoteChecked, setRemoteChecked] = useState<boolean>(
    storedFilter?.invoicefind?.remote || false
  );

  const { t } = useTranslation('global');

  const { statusList, isStatusListLoading } = useGetClientStatusList();

  const handleRemoteChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      form.setValue('remote', event.target.checked ? true : null);
      setRemoteChecked(event.target.checked);
    },
    [form]
  );

  const allPartnersOptions = useMemo(
    () =>
      allPartners
        ? allPartners?.map((partner) => ({
            label: partner.name,
            id: partner.id
          }))
        : [],
    [allPartners]
  );

  const { data: dataDelayClassification } = useQuery(
    [KEYS.catalog.ticketDelayClassification.getAllTicketDelayClassification()],
    () => catalog.ticketDelayClassification.GetAllDelayClassifications(),
    {
      select: (response) => response?.data?.data,
      refetchOnWindowFocus: false
    }
  );

  useEffect(() => {
    if (form.getValues('remote') === false) {
      form.setValue('remote', false);
      setRemoteChecked(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form?.getValues('remote')]);

  return (
    <Box data-testid="ticket-accordion-content">
      <Typography>{t('common.commonProperties.folion')}</Typography>
      <TextFieldElement
        control={form?.control}
        name="ticketId"
        placeholder={t('common.commonProperties.folion')}
        size="small"
        style={{ width: '100%' }}
        type="number"
        validation={{
          minLength: {
            value: 1,
            message: t('ticket.messages.valueLessThan1')
          },
          maxLength: {
            value: 30,
            message: t('ticket.messages.valueLongerThan30')
          }
        }}
        variant="outlined"
      />
      <br />
      <br />
      <Typography>{t('common.commonProperties.ticketStatus')}</Typography>
      <AutocompleteElement
        autocompleteProps={{
          size: 'small',
          placeholder: 'Todos',
          defaultValue: [],
          sx: { width: '100%' }
        }}
        control={form?.control}
        loading={isStatusListLoading}
        name="ticketsStatusIds"
        options={statusList
          .map((status) => ({
            label: status.name,
            id: status.id
          }))
          .filter(
            (status) =>
              hasPerm(status.permission) && status.id !== StatusCode.Reassign
          )}
        rules={{
          minLength: {
            value: 1,
            message: t('ticket.messages.valueLessThan1')
          },
          maxLength: {
            value: 30,
            message: t('ticket.messages.valueLongerThan30')
          }
        }}
        matchId
        multiple
      />
      <br />
      <Grid data-testid="socio-autocomplete">
        <Typography>{t('common.commonProperties.partnerSingular')}</Typography>
        <AutocompleteElement
          autocompleteProps={{
            size: 'small'
          }}
          control={form?.control}
          loading={isAllPartnersLoading}
          name="partnerIds"
          options={allPartnersOptions}
          rules={{
            minLength: {
              value: 1,
              message: t('ticket.messages.valueLessThan1')
            },
            maxLength: {
              value: 30,
              message: t('ticket.messages.valueLongerThan30')
            }
          }}
          matchId
          multiple
        />
      </Grid>
      <br />
      <Grid data-testid="delayTicket-autocomplete">
        <Typography>{t('common.commonProperties.delayTicketName')}</Typography>
        <AutocompleteElement
          autocompleteProps={{
            size: 'small'
          }}
          control={form?.control}
          loading={isAllPartnersLoading}
          name="delayClassificationId"
          options={
            dataDelayClassification?.map((option: { id: any; name: any }) => ({
              id: option?.id,
              label: option?.name
            })) || []
          }
          rules={{
            minLength: {
              value: 1,
              message: t('ticket.messages.valueLessThan1')
            },
            maxLength: {
              value: 30,
              message: t('ticket.messages.valueLongerThan30')
            }
          }}
          matchId
        />
      </Grid>

      <br />
      <Grid data-testid="remote-checkbox">
        <FormControlLabel
          checked={isRemoteChecked}
          control={<Checkbox name="remote" onChange={handleRemoteChange} />}
          label={t('common.commonProperties.remoteAttention')}
          name="remote"
        />
      </Grid>
    </Box>
  );
}

export default TicketsSearching;
